import { useRef, useState } from "react";

import PropTypes, { number } from "prop-types";
import SoftTypography from "components/SoftTypography";
import { Alert, Backdrop, Card, CircularProgress, Snackbar, Typography } from "@mui/material";
import "../style.css";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import SoftBox from "components/SoftBox";
import Table from "examples/Tables/Table";
import { deleteUser, lockUser, unlockUser, resetPassword, importUsersFromExcel } from "api/UserAPI";
import ErrorIcon from "@mui/icons-material/Error";
import addIcon from "assets/images/icons/daikin-admin/report/add_plus_icon.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { disable2FA } from "api/api_register2FA";
import downloadIcon from "assets/images/icons/daikin-admin/report/downloadIcon.svg";
import downloadIconNew from "assets/images/icons/daikin-admin/report/downloadIcon1.svg";
import Swal from "sweetalert2";
import DetaiUser from "./DetaiUser";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import DeleteDialog from "./DeleteUser";
import ResetPassword from "./ResetPassword";
import LockUser from "./LockUser";
import TableData from "../TableData/TableData";
import Reset2FA from "./ResetTwoFA";
import { useColorTheme } from "../../../context/ColorThemeContext";

function UserManagerTables({
  data,
  totalElements,
  curPage,
  setCurPage,
  rowsCount,
  setRowsCount,
  refreshDataAfterChage,
}) {
  const colors = useColorTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDetailOpen, setIsModalDetailOpen] = useState(false);
  const [isModalEditUser, setIsModalEditUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDeleteUser, setIsDeleteUser] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [isLockUser, setIsLockUser] = useState(false);
  const [isReset2FA, setIsReset2FA] = useState(false);
  const [loading, setLoading] = useState(false);
  const { partnerId } = JSON.parse(localStorage.getItem("user"));

  // Thêm ref cho input file
  const fileInputRef = useRef(null);

  // Hàm xử lý khi nhấn nút Import Excel
  const handleImportExcel = () => {
    fileInputRef.current.click();
  };

  // Hàm xử lý khi chọn file
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Tạo FormData và thêm file
    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const result = await importUsersFromExcel(formData);
      setLoading(false);
      if (result.status === 200) {
        Swal.fire({
          title: "Thao tác thành công",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        refreshDataAfterChage();
        setCurPage(curPage);
      } else if (result.status === 201) {
        Swal.fire({
          title: result.message,
          icon: "info",
          showConfirmButton: false,
          timer: 2500,
        });
        refreshDataAfterChage();
        setCurPage(curPage);
      } else {
        Swal.fire({
          title: "Thao tác thất bại",
          icon: "error",
          text: result.message,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } finally {
      // Reset input file
      event.target.value = null;
    }
  };

  const onAction = ({ item, mode }) => {
    setSelectedUser(item);
    if (mode === "VIEW") {
      setIsModalDetailOpen(true);
    } else if (mode === "DELETE") {
      setIsDeleteUser(true);
    } else if (mode === "EDIT") {
      setIsModalEditUser(true);
    } else if (mode === "RESETPASSWORD") {
      setIsResetPassword(true);
    } else if (mode === "LOCK" || mode === "UNLOCK") {
      setIsLockUser(true);
    } else if (mode === "RESET2FA") {
      setIsReset2FA(true);
    }
  };

  const { columns, rows } = TableData({
    onAction,
    data,
    rowsCount,
    curPage,
  });

  const [responseData] = useState({
    message: "",
    status: number,
  });
  const [showSnackBar, setShowSnackBar] = useState(false);

  // VIEW DETAIL USER
  const handleCloseModalDetail = () => {
    setIsModalDetailOpen(false);
  };
  //------------
  // EDIT USER
  const handleCloseModalEditUser = () => {
    setIsModalEditUser(false);
  };
  //---------------------
  //DELETE USER
  const handleCloseDeleteDialog = () => {
    setIsDeleteUser(false);
  };
  const handleCloseReset2FA = () => {
    setIsReset2FA(false);
  };

  const handleReset2FA = async () => {
    const result = await disable2FA(selectedUser.username);
    if (result.status === 200) {
      Swal.fire({
        title: "Thao tác thành công",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
      refreshDataAfterChage();
      setCurPage(curPage);
      setIsReset2FA(false);
    } else {
      Swal.fire({
        title: "Thao tác thất bại",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
      setIsReset2FA(false);
    }
  };
  const handleDeleteUser = () => {
    deleteUser(selectedUser.userId)
      .then((dataTemp) => {
        if (dataTemp) {
          Swal.fire({
            title: "Thao tác thành công",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          console.error("data were not deleted");
        }
      })
      .finally(() => {
        setIsDeleteUser(false);
        refreshDataAfterChage();
      });
  };

  //RESET USER
  const handleResetPassUser = async (newPassword) => {
    try {
      const result = await resetPassword(selectedUser.userId, newPassword);
      if (result.success) {
        Swal.fire({
          title: "Thao tác thành công",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        refreshDataAfterChage();
        setCurPage(curPage);
        setIsResetPassword(false);
      } else {
        Swal.fire({
          title: "Thao tác thất bại",
          text: result.message || "Không thể đặt lại mật khẩu",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
        setIsResetPassword(false);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      Swal.fire({
        title: "Thao tác thất bại",
        text: "Đã xảy ra lỗi khi đặt lại mật khẩu",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
      setIsResetPassword(false);
    }
  };

  const handleCloseResetPassword = () => {
    setIsResetPassword(false);
  };
  //--------------------
  //ADD USER
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseUser = () => {
    setIsModalOpen(false);
  };
  //-----------------------
  // LOCK USER
  const handleCloseLockUser = () => {
    setIsLockUser(false);
  };
  const handleLockUser = async () => {
    const result =
      selectedUser.status === 1
        ? await lockUser(selectedUser.userId)
        : await unlockUser(selectedUser.userId);
    if (result.success) {
      Swal.fire({
        title: "Thao tác thành công",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
      });
      refreshDataAfterChage();
      setCurPage(curPage);
      setIsLockUser(false);
    } else {
      Swal.fire({
        title: "Thao tác thất bại",
        icon: "error",
        showConfirmButton: false,
        timer: 2000,
      });
      setIsLockUser(false);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShowSnackBar(false);
  };
  //----------------------
  console.log(selectedUser);
  return (
    <Card
      style={{
        borderRadius: "7px",
        padding: "0px 16px",
      }}
    >
      <SoftBox
        sx={{
          flexWrap: "wrap",
          padding: "8px 8px",
        }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <SoftBox>
          <SoftTypography mt="5px" fontSize="18px" variant="h6" fontWeight="bold" gutterBottom>
            Danh sách người dùng
          </SoftTypography>
        </SoftBox>
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
          <SoftBox
            color="text"
            sx={{
              cursor: "pointer",
            }}
          >
            <SuiButton
              disabled={false}
              onClick={() => {
                const link = document.createElement("a");
                link.href = `${process.env.PUBLIC_URL}/sample-import/${
                  partnerId === -1 ? "sample-user-admin" : "sample-user"
                }.xlsx`;
                link.download = "sample-user.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              color={colors.popupBackground || "var(--blue-blue-100)"}
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                width: "160px",
              }}
            >
              <img src={downloadIconNew} alt="" />
              <SuiTypography
                whiteSpace="nowrap"
                color={colors.popupText || "white"}
                sx={{
                  fontWeight: "normal",
                  fontSize: "16px",
                  textTransform: "none",
                  marginLeft: "3px",
                }}
              >
                Tải mẫu Import
              </SuiTypography>
            </SuiButton>
          </SoftBox>

          <SoftBox
            color="text"
            sx={{
              cursor: "pointer",
            }}
          >
            <SuiButton
              disabled={false}
              onClick={handleImportExcel}
              color={colors.popupBackground || "var(--blue-blue-100)"}
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                width: "160px",
              }}
            >
              <img src={downloadIcon} alt="" />
              <SuiTypography
                whiteSpace="nowrap"
                color={colors.popupText || "white"}
                sx={{
                  fontWeight: "normal",
                  fontSize: "16px",
                  textTransform: "none",
                  marginLeft: "3px",
                }}
              >
                Import Excel
              </SuiTypography>
            </SuiButton>
            {/* Input file ẩn */}
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".xlsx,.xls"
              onChange={handleFileChange}
            />
          </SoftBox>
          <SoftBox
            color="text"
            sx={{
              cursor: "pointer",
            }}
          >
            <SuiButton
              disabled={false}
              onClick={handleOpenModal}
              color={colors.popupBackground || "var(--blue-blue-100)"}
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                width: "160px",
              }}
            >
              <img src={addIcon} alt="" />
              <SuiTypography
                whiteSpace="nowrap"
                color={colors.popupText || "white"}
                sx={{
                  fontWeight: "normal",
                  fontSize: "16px",
                  textTransform: "none",
                  marginLeft: "3px",
                }}
              >
                Thêm mới
              </SuiTypography>
            </SuiButton>
          </SoftBox>
        </div>
      </SoftBox>

      <Table
        columns={columns}
        rows={rows}
        isPagination={true}
        totalElements={totalElements}
        rowsPerPageOptions={[5, 10, 15, 20]}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        curPage={curPage}
        setCurPage={setCurPage}
      />
      <SuiTypography
        whiteSpace="nowrap"
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          textTransform: "none",
          alignItems: "center",
          display: "flex",
          flex: 1,
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        {data.length <= 0 && "Không tồn tại dữ liệu"}
      </SuiTypography>
      <DetaiUser
        selectedUser={selectedUser}
        open={isModalDetailOpen}
        onClose={handleCloseModalDetail}
      />
      <AddUser
        refreshDataAfterChage={refreshDataAfterChage}
        open={isModalOpen}
        onClose={handleCloseUser}
      />
      <EditUser
        refreshDataAfterChage={refreshDataAfterChage}
        open={isModalEditUser}
        onClose={handleCloseModalEditUser}
        userToEdit={selectedUser}
      />
      {isDeleteUser && (
        <DeleteDialog
          open={isDeleteUser}
          onClose={handleCloseDeleteDialog}
          onDelete={handleDeleteUser}
          id={selectedUser?.fullName}
        />
      )}
      <ResetPassword
        open={isResetPassword}
        onClose={handleCloseResetPassword}
        onResetPass={handleResetPassUser}
        selectedUser={selectedUser}
      />
      {isLockUser && (
        <LockUser
          open={isLockUser}
          onClose={handleCloseLockUser}
          onLock={handleLockUser}
          state={selectedUser?.status}
        />
      )}
      <Reset2FA open={isReset2FA} onClose={handleCloseReset2FA} onReset={handleReset2FA} />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showSnackBar}
        autoHideDuration={1500}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          variant="filled"
          // sx={{ backgroundColor: responseData.status === 200 ? "#39ac39" : "#f44336" }}
          icon={
            responseData.status === 200 ? (
              <CheckCircleOutlineIcon style={{ color: "white" }} />
            ) : (
              <ErrorIcon style={{ color: "white" }} />
            )
          }
          severity={responseData.status === 200 ? "success" : "error"}
        >
          {responseData.status === 200 ? (
            <Typography color="white" variant="body2">
              Thao tác thành công
            </Typography>
          ) : (
            <Typography color="white" variant="body2">
              Thao tác thất bại
            </Typography>
          )}
        </Alert>
      </Snackbar>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Card>
  );
}

UserManagerTables.propTypes = {
  data: PropTypes.arrayOf(Object).isRequired,
  totalElements: PropTypes.number.isRequired,
  curPage: PropTypes.number.isRequired,
  setCurPage: PropTypes.func.isRequired,
  rowsCount: PropTypes.number.isRequired,
  setRowsCount: PropTypes.func.isRequired,
  refreshDataAfterChage: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
};

export default UserManagerTables;
